var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "97.696%",
    y2: "2.304%",
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EB2FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "logo_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27DE7C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADFF83",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "18.255%",
    x2: "98.782%",
    y2: "81.907%",
    id: "logo_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202756",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3856",
    stopOpacity: 0.994,
    offset: "21.396%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3956",
    offset: "48.392%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191C32",
    stopOpacity: 0.7,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "logo_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EB2FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "99.468%",
    y2: ".532%",
    id: "logo_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27DE7C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADFF83",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.365 12.261 7.751-5.41a.776.776 0 0 1 .29-.09V.072c-.124-.01-.315.08-.331.08L.365 5.57a.48.48 0 0 0-.332.441v5.896c0 .194.15.353.332.353Z",
    transform: "rotate(90 14.83 15.186)",
    fill: "url(#logo_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.332 12.262 7.751-5.41a.776.776 0 0 1 .29-.09V.073c-.124-.01-.315.08-.332.08L.332 5.571A.48.48 0 0 0 0 6.012v5.896c0 .194.15.353.332.353Z",
    transform: "matrix(0 -1 -1 0 30.015 17.121)",
    fill: "url(#logo_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.58 18.226.358 6.956C.174 6.86.025 6.71.025 6.514V.557c0-.283.133-.398.324-.495l16.1 11.393a.48.48 0 0 1 .331.442l-.008 5.958c-.025.194-.083.283-.191.371Z",
    opacity: 0.7,
    transform: "rotate(90 12.071 12.427)",
    fill: "url(#logo_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.365 12.261 7.751-5.41a.776.776 0 0 1 .29-.09V.072c-.124-.01-.315.08-.331.08L.365 5.57a.48.48 0 0 0-.332.441v5.896c0 .194.15.353.332.353Z",
    transform: "rotate(-90 8.858 8.35)",
    fill: "url(#logo_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.332 12.262 7.751-5.41a.776.776 0 0 1 .29-.09V.073c-.124-.01-.315.08-.332.08L.332 5.571A.48.48 0 0 0 0 6.012v5.896c0 .194.15.353.332.353Z",
    transform: "matrix(0 1 1 0 .507 .443)",
    fill: "url(#logo_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.598 6.085c.629-1.27 1.637-1.906 3.026-1.906 1.18 0 2.067.387 2.663 1.16.596.772.894 1.794.894 3.065v5.58h-2.319v-5.58c0-.707-.17-1.241-.51-1.601-.341-.36-.82-.54-1.435-.54-.616 0-1.143.274-1.582.824-.44.55-.672 1.376-.698 2.476v4.422h-2.319v-9.55h2.024l.256 1.65Zm13.107 2.319c.76 0 1.637.124 2.633.373v-.943c0-.668-.134-1.162-.403-1.483-.268-.321-.707-.482-1.316-.482-.61 0-1.078.121-1.406.364-.327.242-.49.586-.49 1.031h-2.536c0-1.087.383-1.873 1.15-2.358.766-.484 1.837-.727 3.213-.727 1.965 0 3.236.688 3.812 2.063.196.472.295 1.029.295 1.67v6.073h-2.024l-.177-1.278c-.616 1.035-1.56 1.553-2.83 1.553-1.231 0-2.188-.301-2.869-.904-.629-.576-.943-1.307-.943-2.191 0-.884.347-1.566 1.041-2.044.695-.478 1.645-.717 2.85-.717Zm2.633 1.847c-.773-.21-1.494-.314-2.162-.314-1.257 0-1.886.419-1.886 1.257 0 .354.144.659.432.914.288.256.75.383 1.386.383.635 0 1.159-.213 1.572-.638.412-.426.632-.96.658-1.602Zm14.188-4.009c.615-1.375 1.696-2.063 3.242-2.063 1.14 0 2.024.387 2.653 1.16.602.733.904 1.755.904 3.065v5.58h-2.339v-5.58c0-.707-.17-1.241-.51-1.601-.341-.36-.82-.54-1.435-.54-.616 0-1.12.268-1.513.805-.393.537-.603 1.35-.629 2.436v4.48H70.58v-5.58c0-.707-.17-1.241-.51-1.601-.341-.36-.82-.54-1.435-.54-.616 0-1.143.274-1.582.824-.439.55-.671 1.376-.698 2.476v4.422h-2.318v-9.55h2.024l.255 1.65c.629-1.27 1.638-1.906 3.026-1.906.8 0 1.464.184 1.995.55.53.367.927.872 1.189 1.513Zm17.557.786a5.34 5.34 0 0 1 .246 1.514c0 .458-.026.87-.079 1.238h-6.17c.026.772.216 1.401.57 1.886.354.485.89.727 1.611.727.957 0 1.527-.42 1.71-1.258h2.338c-.157.957-.596 1.71-1.316 2.26-.747.577-1.657.865-2.732.865-1.257 0-2.312-.459-3.163-1.376-.878-.956-1.317-2.18-1.317-3.674 0-1.533.439-2.764 1.317-3.695.838-.89 1.893-1.336 3.163-1.336 1.323 0 2.352.465 3.085 1.395.328.42.574.904.737 1.454Zm-3.802-1.002c-.655 0-1.166.213-1.533.639-.367.426-.583.973-.648 1.64h4.067c0-1.034-.327-1.728-.982-2.082-.249-.131-.55-.197-.904-.197Zm8.116 5.05c.026.904.687 1.356 1.984 1.356.498 0 .908-.108 1.228-.324.321-.216.482-.468.482-.756 0-.289-.098-.511-.295-.669-.196-.157-.504-.3-.923-.432l-2.083-.747c-1.546-.537-2.32-1.414-2.32-2.633 0-.812.364-1.464 1.091-1.955.728-.491 1.704-.737 2.928-.737 1.225 0 2.169.269 2.83.806.662.537 1.006 1.212 1.032 2.024H98.17a.957.957 0 0 0-.452-.747c-.276-.183-.669-.275-1.18-.275-.51 0-.907.102-1.188.305-.282.203-.423.435-.423.697 0 .459.387.8 1.16 1.022l2.26.845c.746.249 1.32.567 1.719.953.4.386.6.888.6 1.503 0 .786-.374 1.468-1.12 2.044-.774.603-1.796.904-3.066.904-1.271 0-2.293-.279-3.066-.835-.773-.557-1.166-1.34-1.179-2.349h2.162Zm11.18-5.344c.603-1.035 1.52-1.553 2.752-1.553 1.179 0 2.188.446 3.026 1.336.89.944 1.336 2.175 1.336 3.695 0 1.532-.452 2.77-1.356 3.714-.838.89-1.84 1.336-3.006 1.336-1.166 0-2.018-.347-2.555-1.042v5.424h-2.318V4.435h1.906l.216 1.297Zm2.34 6.425c.274 0 .56-.059.854-.177.295-.117.56-.3.796-.55.524-.55.786-1.287.786-2.21 0-.924-.226-1.648-.678-2.172-.452-.524-1.002-.786-1.65-.786-.65 0-1.18.187-1.592.56-.413.374-.633.907-.659 1.602v1.71c0 .615.216 1.113.649 1.493.406.353.904.53 1.493.53Zm10.67-3.753c.76 0 1.637.124 2.633.373v-.943c0-.668-.135-1.162-.403-1.483-.269-.321-.708-.482-1.317-.482s-1.077.121-1.405.364c-.327.242-.491.586-.491 1.031h-2.535c0-1.087.383-1.873 1.15-2.358.766-.484 1.837-.727 3.212-.727 1.965 0 3.236.688 3.813 2.063.196.472.294 1.029.294 1.67v6.073h-2.024l-.177-1.278c-.615 1.035-1.558 1.553-2.83 1.553-1.23 0-2.187-.301-2.868-.904-.629-.576-.943-1.307-.943-2.191 0-.884.347-1.566 1.041-2.044s1.644-.717 2.85-.717Zm2.633 1.847c-.773-.21-1.494-.314-2.162-.314-1.258 0-1.886.419-1.886 1.257 0 .354.144.659.432.914.288.256.75.383 1.385.383.636 0 1.16-.213 1.572-.638.413-.426.632-.96.659-1.602Zm9.334-6.072c.602 0 1.143.102 1.62.305.479.203.882.468 1.21.796.654.628 1.04 1.421 1.159 2.377l-2.339.06a2.15 2.15 0 0 0-.58-1.042 1.352 1.352 0 0 0-.972-.413c-.367 0-.681.056-.943.167a1.813 1.813 0 0 0-.688.52c-.446.551-.668 1.31-.668 2.28 0 .97.21 1.7.629 2.191.419.492.926.737 1.522.737.597 0 1.029-.14 1.297-.422.269-.282.403-.665.403-1.15h2.339c0 1.048-.348 1.92-1.042 2.614-.707.707-1.696 1.06-2.967 1.06-1.258 0-2.312-.458-3.164-1.375-.904-.982-1.356-2.207-1.356-3.674 0-1.546.452-2.784 1.356-3.714.852-.878 1.913-1.317 3.184-1.317Zm14.177 2.85a5.34 5.34 0 0 1 .246 1.513c0 .458-.026.87-.079 1.238h-6.17c.026.772.216 1.401.57 1.886.354.485.89.727 1.611.727.957 0 1.527-.42 1.71-1.258h2.338c-.157.957-.596 1.71-1.316 2.26-.747.577-1.657.865-2.732.865-1.257 0-2.312-.459-3.163-1.376-.878-.956-1.317-2.18-1.317-3.674 0-1.533.439-2.764 1.317-3.695.838-.89 1.893-1.336 3.163-1.336 1.324 0 2.352.465 3.086 1.395.327.42.573.904.736 1.454Zm-3.802-1.003c-.655 0-1.166.213-1.533.639-.366.426-.583.973-.648 1.64h4.068c0-1.034-.328-1.728-.983-2.082-.249-.131-.55-.197-.904-.197Z",
    fill: "#FFF"
  }))));
};

export default SvgLogo;